var version = {
    "name":      "dativery",
    "buildDateCode": "20261105-163231",
    "buildDate": "Thu Nov 05 2026 16:32:31 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20261105-163231",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;